import { render, staticRenderFns } from "./accountProfilePage.vue?vue&type=template&id=015a8e76&scoped=true"
import script from "./accountProfilePage.vue?vue&type=script&lang=js"
export * from "./accountProfilePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015a8e76",
  null
  
)

export default component.exports